import { c as _c } from "react/compiler-runtime";
import React, { PropsWithChildren } from 'react';
import { motion } from 'framer-motion';
import { mergeClasses } from '@/utils/style';
interface Props {
  icon?: JSX.Element;
  onClick?: () => void;
  isActive?: boolean;
  className?: string;
}
function SheetItem(props) {
  const $ = _c(10);
  const {
    icon,
    onClick,
    children,
    className
  } = props;
  const t0 = props.isActive === true;
  let t1;
  if ($[0] !== className || $[1] !== t0) {
    t1 = mergeClasses("flex w-full bg-transparent px-6 py-3 text-left transition-all duration-100 ease-in-out", {
      "bg-gray-50 font-semibold": t0
    }, className);
    $[0] = className;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== icon) {
    t2 = icon && <div className="h-6 w-6 text-black">{icon}</div>;
    $[3] = icon;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== onClick || $[7] !== t1 || $[8] !== t2) {
    t3 = <motion.button onClick={onClick} className={t1}>{t2}{children}</motion.button>;
    $[5] = children;
    $[6] = onClick;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
export default SheetItem;